export default __webpack_public_path__ + "static/media/shangpin_w.5ab49168.png";